import React, { useMemo, useState } from 'react';
import { useSupplementsList } from '../../../contextsProperty/ContextSupplements';
import useCalendar from '../../../../customHooks/useCalendar';
import {
    CalendarEvent,
    CalendarView,
} from '../../../../types/calendar/calendarTypes';
import { ISupplementListState } from '../../../../types/supplement/supplementsTypes';
import { isDateless } from '../../../../utils/formatDates';
import Calendar from '../../../../components/calendar/Calendar';
import SwitchInput from '../../../../muiComponents/switchInput/SwitchInput';
import SupplementEvent from './SupplementEvent';

const SupplementsCalendar = () => {
    const { items, isLoading } = useSupplementsList();
    const {
        calendarRef,
        activeView,
        changeView,
        goToDate,
        prev,
        next,
        today,
        idHoveredEvent,
        hoverEvent,
        unhoverEvent,
    } = useCalendar({
        initialView: CalendarView.MONTH,
    });

    const [datelessVisible, setDatelessVisible] = useState(false);

    const events: CalendarEvent<ISupplementListState>[] = useMemo(() => {
        return items
            .map(item => {
                return {
                    id: item.Id,
                    title: item.Name,
                    start: item.FromDate,
                    end: item.ToDate,
                    allDay: true,
                    extendedProps: {
                        ...item,
                    },
                };
            })
            .filter(event => {
                if (datelessVisible) return true;
                const fromDateless = isDateless(event.extendedProps.FromDate);
                const toDateless = isDateless(event.extendedProps.ToDate);
                return !fromDateless && !toDateless;
            });
    }, [items, datelessVisible]);

    const renderEvent = (event: CalendarEvent<ISupplementListState>) => {
        return (
            <SupplementEvent
                event={event}
                idHoveredEvent={idHoveredEvent}
                hoverEvent={hoverEvent}
                unhoverEvent={unhoverEvent}
            />
        );
    };

    return (
        <div className='flex-grow overflow-y-auto'>
            <Calendar
                calendarRef={calendarRef}
                events={events}
                renderEvent={renderEvent}
                eventColor={'var(--background)'}
                isLoading={isLoading}
                onNext={next}
                onPrev={prev}
                onToday={today}
                onViewChange={changeView}
                onGoToDate={goToDate}
                activeView={activeView}
                headerProps={{
                    titleButtonbarEnd: (
                        <SwitchInput
                            labelText={
                                datelessVisible ? 'all_taxes' : 'with_date_only'
                            }
                            checked={!datelessVisible}
                            onChangeMethod={(
                                _event: React.ChangeEvent<HTMLInputElement>,
                                checked: boolean
                            ) => setDatelessVisible(!checked)}
                        />
                    ),
                }}
            />
        </div>
    );
};

export default SupplementsCalendar;
